import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { BookOpen, Headphones, FileText } from "lucide-react";

const ICONS = { Article: BookOpen, Audio: Headphones, Guide: FileText };

export default function Resources() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/resources").then((r) => setItems(r.data)); }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16" data-testid="resources-page">
      <div className="text-xs uppercase tracking-[0.28em] text-[#C93B3B]">Digital library</div>
      <h1 className="font-serif text-5xl lg:text-6xl mt-4 text-[#F7ECEB]">Read, listen, and settle in.</h1>
      <p className="text-[#A89896] mt-6 max-w-2xl">Curated writing and audio for members walking the path of consent, closeness, and self-reclamation.</p>

      <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((r, i) => {
          const Ico = ICONS[r.type] || BookOpen;
          return (
            <div key={r.id} className="tt-card p-8 tt-fade-up" style={{ animationDelay: `${i * 80}ms` }} data-testid={`resource-${r.id}`}>
              <Ico className="w-6 h-6 text-[#C93B3B]" strokeWidth={1.4} />
              <div className="text-xs uppercase tracking-[0.2em] text-[#A89896] mt-6">{r.category} · {r.read_time}</div>
              <h3 className="font-serif text-2xl mt-2 text-[#F7ECEB]">{r.title}</h3>
              <p className="text-sm text-[#A89896] mt-4 leading-relaxed">{r.excerpt}</p>
              <button className="mt-6 text-sm text-[#C93B3B] underline" data-testid={`resource-open-${r.id}`}>Open →</button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
